import React, { useState } from 'react';
import { Button, ButtonSizes, ButtonStyles } from '@quantum/ui-atoms';
import { Choice } from '@/machines/types';
import { SelectButton } from '@/components/select-button';
import * as styles from './styles.module.scss';

interface MultiSelectProps {
  choices: Choice[];
  onClick: (choices: Choice[]) => void;
}

const unique = 'CheckBoxNone';

export const MultiSelect: React.FC<MultiSelectProps> = ({ choices, onClick }) => {
  const [selectedAnswers, setSelectedAnswers] = useState<Choice[]>([]);

  const updateSelected = (choice: Choice): void => {
    let selectedAnswer: Choice[] = [];

    if (choice.answerTypeString !== unique) {
      const filteredSelectedAnswers = selectedAnswers.filter(({ answerTypeString }) => answerTypeString !== unique);
      if (selectedAnswers.includes(choice)) {
        selectedAnswer = filteredSelectedAnswers.filter(answer => answer !== choice);
      } else {
        selectedAnswer = [...filteredSelectedAnswers, choice];
      }
    } else if (!selectedAnswers.includes(choice)) {
      selectedAnswer = [choice];
    }

    setSelectedAnswers(selectedAnswer);
  };

  return (
    <>
      {choices.map(choice => (
        <div key={`${choice.index}${choice.next.male.nextQuestionId || choice.index}`} className={styles.choice}>
          <SelectButton
            canSelect
            isSelected={selectedAnswers.includes(choice)}
            text={choice.text}
            onClick={() => updateSelected(choice)}
          />
        </div>
      ))}
      <div className={styles.button}>
        <Button
          animate
          fullWidth
          text='Next Question'
          buttonStyle={ButtonStyles.primary}
          size={ButtonSizes.large}
          disabled={selectedAnswers.length === 0}
          onClick={() => onClick(selectedAnswers)}
        />
      </div>
    </>
  );
};
